export default {
  path: '/wecode/solution',
  auth: false,
  preload: false,
  key: 'new-solution',
  component: () => import('./index')
};
